import { useContext } from 'react';
// import uuid from 'lib/misc/uuid';
// import useMounted from 'hooks/useMounted';
import { uuid, useMounted, ToastContext } from '@archre2/react-core';

function useToastManager() {
  const { dispatch } = useContext(ToastContext);
  const isMounted = useMounted();
  const add = (content, options = {}, timeout = 0) => {
    if (!isMounted.current) return;

    let id = uuid();
    if (timeout > 0) {
      dispatch({
        type: 'ADD_TIMEDOUT',
        id,
        timeout,
        payload: {
          content,
          ...options,
        },
      });
    }
    setTimeout(function setToast() {
      dispatch({
        type: 'ADD',
        id,
        timeout,
        payload: {
          content,
          ...options,
        },
      });
    }, timeout);
    return id;
  };

  const remove = (id) => {
    if (!isMounted.current) return;
    dispatch({ type: 'DELETE', payload: id });
  };
  return { add, remove };
}

export default useToastManager;
